module.exports = __webpack_public_path__ + "media/images/buttons/button-social-twitter-febf29c7352f0f999799f8f4f2b58c85.svg";